import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {ApplicationSetting} from '../../models/application-settings/application-settings.model';

@Injectable({
  providedIn: 'root'
})
export class ApplicationSettingsService {
  private apiUrl = `${environment.backend.url}/api/settings/v1`;

  constructor(private http: HttpClient) { }

  /**
   * Get all settings
   */
  getSettings(): Observable<ApplicationSetting[]> {
    return this.http.get<ApplicationSetting[]>(`${this.apiUrl}/list`);
  }

  /**
   * Get setting by key
   * @param key Setting key
   */
  getSettingByKey(key: string): Observable<ApplicationSetting> {
    return this.http.get<ApplicationSetting>(`${this.apiUrl}/by-key/${key}`);
  }

  /**
   * Update setting
   * @param setting Setting to update
   * @deprecated Use updateSettings for batch updates
   */
  updateSetting(setting: ApplicationSetting): Observable<any> {
    return this.http.put(`${this.apiUrl}/update`, setting);
  }

  /**
   * Update multiple settings at once
   * @param settings Array of settings to update
   */
  updateSettings(settings: ApplicationSetting[]): Observable<any> {
    return this.http.put(`${this.apiUrl}/update`, settings);
  }
}
